module.exports = ".btn_flex {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.table__cell {\r\n  padding: 10px;\r\n}\r\n"